import React, { Component } from "react";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import { setFastTrackAppointments } from "../../actions/claims/claimsActions";
import { withRouter, Redirect } from "react-router-dom";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import Article from "../shared/Article";
import Store from "../../content/Store";
import HelpSection from "../shared/HelpSection";
import style from "../../assets/css/modules/claims/claims.css";
import appointmentstyle from "../../assets/css/modules/claims/appointments.css";
import Button from "../shared/buttons/Button";
import { Paths } from "../../constants/UrlConstants";
import PromoContainer from "../shared/containers/PromoContainer";
import PromoImageCard from "../../components/shared/PromoImageCard";

export const mapStateToAppointments = (state) => {
  let appointments =
    state &&
    state.claimsReducer &&
    state.claimsReducer.selectedPolicy.appointments;
  let membershipNumber =
    state &&
    state.policyReducer &&
    state.policyReducer.selectedPolicy &&
    state.policyReducer.selectedPolicy.MembershipNumber;
  return {
    appointments: appointments,
    membershipNumber
  };
};

export class Appointments extends Component {
  componentDidMount() {
    this.props.setFastTrackAppointments &&
      this.props.setFastTrackAppointments(this.props.membershipNumber);
  }

  appointmentHandler = (index) => {
    this.props.history.push(Paths.AppointmentDetail, { index });
  };

  render() {
    return (
      <div className={style.claims}>
        <ShadowedContainer>
          {this.props.appointments && this.props.appointments.length === 0 ? (
            <Redirect to={Paths.FastTrack} />
          ) : (
            <React.Fragment>
              <div className="row">
                <div className={"col-lg-8 " + style.articleDescription}>
                  <Article
                    header={Store.Appointments.Heading}
                    body={Store.Appointments.Description}
                  />
                </div>
              </div>
              <div className={appointmentstyle.appointmentSection}>
                {this.props.appointments &&
                this.props.appointments.length > 0 ? (
                  <div>
                    {this.props.appointments.map((appointment, key) => {
                      return (
                        <div
                          className={
                            "row appointmentRow " + appointmentstyle.appointment
                          }
                          key={key}
                        >
                          <div className="col-sm-2 col-lg-1 ">
                            <i className={"icon-functional-calendar-outline"} />
                          </div>
                          <div
                            className={
                              "col-sm-10 col-lg-8 " +
                              appointmentstyle.appointmentContent
                            }
                          >
                            <div className={appointmentstyle.dateTime}>
                              {appointment.AppointmentDate} -{" "}
                              {appointment.AppointmentTime}
                            </div>
                            <span className={appointmentstyle.description}>
                              {appointment.TreatmentCategory &&
                                appointment.TreatmentCategory + " • "}
                            </span>
                            <span className={appointmentstyle.description}>
                              {appointment.HospitalName &&
                                appointment.HospitalName + " • "}
                            </span>
                            <span className={appointmentstyle.description}>
                              {appointment.SpecialistName}
                            </span>
                          </div>
                          <div className="col-lg-3 ">
                            <Button
                              buttonType="primaryBlueButton"
                              label={Store.Appointments.ViewDetailsLabel}
                              onClick={() => this.appointmentHandler(key)}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
              <HelpSection
                HeadingLinkTo={Store.Appointments.HelpSection.HeadingLinkTo}
                HeadingLinkText={Store.Appointments.HelpSection.HeadingLinkText}
                MoreHelpLinkTo={Store.Appointments.HelpSection.MoreHelpLinkTo}
                MoreHelpLinkText={
                  Store.Appointments.HelpSection.MoreHelpLinkText
                }
                HelpSet={Store.Appointments.HelpSection.HelpSet}
              />
            </React.Fragment>
          )}
        </ShadowedContainer>

        <PromoContainer>
          <PromoImageCard
            ImgSrc={Store.Home.Cards.AskMedExpert.IconSrc}
            ImgSrcMobile={Store.Home.Cards.AskMedExpert.IconSrcMobile}
            Heading={Store.Home.Cards.AskMedExpert.Heading}
            Description={Store.Home.Cards.AskMedExpert.Description}
            LinkText={Store.Home.Cards.AskMedExpert.LinkText}
            LinkTo={Store.Home.Cards.AskMedExpert.LinkTo}
            LeftImage
          />
        </PromoContainer>
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToAppointments, { setFastTrackAppointments })(
    Contentify(Appointments)
  )
);
